var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-manager',{attrs:{"isLogo":_vm.isLogo}})}
var staticRenderFns = []

export { render, staticRenderFns }